import { connect } from 'react-redux'
import React from 'react'
import SignIn from '../pages/signin/SignIn'

const SignUp = ({ params, location }) => (
  <div className='s_p_a signin-container'>
    <SignIn action='signup' viewParams={{ ...params, query: location.query }} />
  </div>
)

export default connect()(SignUp)
